export default __webpack_public_path__ + "static/media/specialist@3x.4aa4a5b4.jpg";